export enum CancelReasonTypeEnum {
	None = 0,
	PassengerNoShow = 1,
	PassengerWithChild = 2,
	TooManyPassengersOrLuggage = 3,
	CreatePaymentFailed = 4,
	Accident = 5,
	DoubleBooking = 6,
	PassengerChangedMind = 7,
	PassengerHasDesignated = 8,
	BookedWrongDate = 9,
	BookedWrongRoute = 10,
	Other = 100
}
